export default __webpack_public_path__ + "static/media/header_hero.69f04f3e.jpg";